/** Fixed route slug per stage number (matches theme DAY_CONFIG game type). */
export const STAGE_GAME_SLUGS = {
  1: 'super-power-squad',
  2: 'comic-strip-chaos',
  3: 'category-rush',
  4: 'word-chain',
  5: 'wordle',
  6: 'team-anthem',
  7: 'super-squad',
  8: 'wild-tales',
  9: 'letter-loot',
  10: 'native-places',
};

const SLUG_TO_STAGE = Object.fromEntries(
  Object.entries(STAGE_GAME_SLUGS).map(([n, slug]) => [slug, Number(n)])
);

export function getStagePath(stageNumber) {
  const n = Number(stageNumber);
  const slug = STAGE_GAME_SLUGS[n];
  return slug ? `/${slug}` : null;
}

export function parseStageNumberFromPath(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '').toLowerCase();

  const legacy = path.match(/^\/stage(\d{1,2})$/);
  if (legacy) return Number(legacy[1]);

  const slug = path.startsWith('/') ? path.slice(1) : path;
  if (SLUG_TO_STAGE[slug] != null) return SLUG_TO_STAGE[slug];

  return null;
}

export function isStagePath(pathname) {
  return parseStageNumberFromPath(pathname) != null;
}
